"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMarkdown = exports.parseInlineMarkdown = exports.CodeBlockWrapper = exports.parseEmojiShortcodes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const EMOJI_MAP = {
    ':fire:': '🔥',
    ':rocket:': '🚀',
    ':check:': '✅',
    ':x:': '❌',
    ':warning:': '⚠️',
    ':info:': 'ℹ️',
    ':star:': '⭐',
    ':heart:': '❤️',
    ':sparkles:': '✨',
    ':smile:': '😊',
    ':laughing:': '😄',
    ':thumbsup:': '👍',
    ':thumbsdown:': '👎',
    ':eyes:': '👀',
    ':wave:': '👋',
    ':tada:': '🎉',
    ':party:': '🎉',
    ':gear:': '⚙️',
    ':lock:': '🔒',
    ':unlock:': '🔓',
    ':bell:': '🔔',
    ':bug:': '🐛',
    ':wrench:': '🔧',
    ':computer:': '💻',
    ':globe:': '🌐',
    ':chart:': '📊',
    ':robot:': '🤖',
};
const KNOWN_LANGUAGES = [
    'ini', 'yaml', 'yml', 'fix', 'diff', 'elm', 'text', 'txt', 'json', 'js',
    'javascript', 'ts', 'typescript', 'py', 'python', 'css', 'html', 'sql',
    'sh', 'bash', 'cpp', 'c', 'cs', 'java', 'md', 'markdown', 'go', 'rust',
    'php', 'rb', 'ruby', 'xml', 'dockerfile', 'graphql'
];
const parseEmojiShortcodes = (str) => {
    if (!str)
        return '';
    return str.replace(/:[a-z0-9_]+:/gi, (match) => EMOJI_MAP[match.toLowerCase()] || match);
};
exports.parseEmojiShortcodes = parseEmojiShortcodes;
const formatDiscordTimestamp = (unixSeconds, style) => {
    const date = new Date(unixSeconds * 1000);
    if (isNaN(date.getTime())) {
        return { text: `<t:${unixSeconds}>`, full: '' };
    }
    const fullStr = date.toLocaleString('tr-TR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
    if (style === 'R' || style === 'r') {
        const now = Math.floor(Date.now() / 1000);
        const diff = now - unixSeconds;
        const absDiff = Math.abs(diff);
        let relativeStr = '';
        if (absDiff < 60)
            relativeStr = diff >= 0 ? 'biraz önce' : 'birazdan';
        else if (absDiff < 3600)
            relativeStr = `${Math.floor(absDiff / 60)} dakika ${diff >= 0 ? 'önce' : 'sonra'}`;
        else if (absDiff < 86400)
            relativeStr = `${Math.floor(absDiff / 3600)} saat ${diff >= 0 ? 'önce' : 'sonra'}`;
        else if (absDiff < 2592000)
            relativeStr = `${Math.floor(absDiff / 86400)} gün ${diff >= 0 ? 'önce' : 'sonra'}`;
        else if (absDiff < 31536000)
            relativeStr = `${Math.floor(absDiff / 2592000)} ay ${diff >= 0 ? 'önce' : 'sonra'}`;
        else
            relativeStr = `${Math.floor(absDiff / 31536000)} yıl ${diff >= 0 ? 'önce' : 'sonra'}`;
        return { text: relativeStr, full: fullStr };
    }
    return { text: fullStr, full: fullStr };
};
/**
 * Discord Syntax Highlighter
 */
const renderHighlightedCode = (code, language) => {
    const lang = language.toLowerCase();
    // Diff highlighting
    if (lang === 'diff') {
        const lines = code.split('\n');
        return lines.map((line, idx) => {
            let lineClass = 'syntax-diff-neutral';
            if (line.startsWith('+'))
                lineClass = 'syntax-diff-add';
            else if (line.startsWith('-'))
                lineClass = 'syntax-diff-remove';
            else if (line.startsWith('!'))
                lineClass = 'syntax-diff-warn';
            else if (line.startsWith('@@') || line.startsWith('***'))
                lineClass = 'syntax-diff-header';
            return ((0, jsx_runtime_1.jsx)("div", { className: `syntax-line ${lineClass}`, children: line || ' ' }, idx));
        });
    }
    // INI highlighting
    if (lang === 'ini') {
        const lines = code.split('\n');
        return lines.map((line, idx) => {
            // Check section header or badge [STATUS]: ONLINE
            const sectionMatch = line.match(/^(\s*)(\[[^\]]+\])(.*)$/);
            if (sectionMatch) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "syntax-line", children: [sectionMatch[1], (0, jsx_runtime_1.jsx)("span", { className: "syntax-ini-section", children: sectionMatch[2] }), (0, jsx_runtime_1.jsx)("span", { className: "syntax-ini-val", children: sectionMatch[3] })] }, idx));
            }
            // Check key = value or key: value
            const kvMatch = line.match(/^(\s*)([^:=]+)([:=])(.*)$/);
            if (kvMatch) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "syntax-line", children: [kvMatch[1], (0, jsx_runtime_1.jsx)("span", { className: "syntax-ini-key", children: kvMatch[2] }), (0, jsx_runtime_1.jsx)("span", { className: "syntax-ini-sep", children: kvMatch[3] }), (0, jsx_runtime_1.jsx)("span", { className: "syntax-ini-val", children: kvMatch[4] })] }, idx));
            }
            return (0, jsx_runtime_1.jsx)("div", { className: "syntax-line", children: line || ' ' }, idx);
        });
    }
    // FIX highlighting (status messages, logs, terminal states)
    if (lang === 'fix') {
        const lines = code.split('\n');
        return lines.map((line, idx) => {
            // Colorize brackets [STATUS], status words ONLINE, NOMINAL, etc.
            const tokens = line.split(/(\[[^\]]+\]|\b(?:ONLINE|NOMINAL|AKTİF|ACTIVE|SUCCESS|PASS|OK)\b|\b(?:OFFLINE|ERROR|CRITICAL|FAIL|DOWN|HATA)\b|\b(?:WARNING|WARN|PENDING|RETRY)\b|\b\d+(?:[\.-]\w+)?\b)/gi);
            return ((0, jsx_runtime_1.jsx)("div", { className: "syntax-line", children: tokens.map((tok, tIdx) => {
                    if (/^\[[^\]]+\]$/.test(tok)) {
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-fix-badge", children: tok }, tIdx);
                    }
                    if (/^(ONLINE|NOMINAL|AKTİF|ACTIVE|SUCCESS|PASS|OK)$/i.test(tok)) {
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-fix-ok", children: tok }, tIdx);
                    }
                    if (/^(OFFLINE|ERROR|CRITICAL|FAIL|DOWN|HATA)$/i.test(tok)) {
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-fix-err", children: tok }, tIdx);
                    }
                    if (/^(WARNING|WARN|PENDING|RETRY)$/i.test(tok)) {
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-fix-warn", children: tok }, tIdx);
                    }
                    if (/^\d+(?:[\.-]\w+)?$/.test(tok)) {
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-fix-num", children: tok }, tIdx);
                    }
                    return (0, jsx_runtime_1.jsx)("span", { children: tok }, tIdx);
                }) }, idx));
        });
    }
    // YAML / YML highlighting
    if (lang === 'yaml' || lang === 'yml') {
        const lines = code.split('\n');
        return lines.map((line, idx) => {
            const kvMatch = line.match(/^(\s*)([a-zA-Z0-9_ğüşıöçĞÜŞİÖÇ\s-]+:)(.*)$/);
            if (kvMatch) {
                return ((0, jsx_runtime_1.jsxs)("div", { className: "syntax-line", children: [kvMatch[1], (0, jsx_runtime_1.jsx)("span", { className: "syntax-yaml-key", children: kvMatch[2] }), (0, jsx_runtime_1.jsx)("span", { className: "syntax-yaml-val", children: kvMatch[3] })] }, idx));
            }
            return (0, jsx_runtime_1.jsx)("div", { className: "syntax-line", children: line || ' ' }, idx);
        });
    }
    // ELM highlighting (often used for badges/short values)
    if (lang === 'elm') {
        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-elm-badge", children: code });
    }
    // JSON highlighting
    if (lang === 'json') {
        const lines = code.split('\n');
        return lines.map((line, idx) => {
            return ((0, jsx_runtime_1.jsx)("div", { className: "syntax-line", children: line.split(/(".*?"|:\s*true|:\s*false|:\s*null|:\s*\d+)/g).map((part, pIdx) => {
                    if (part.startsWith('"') && part.endsWith('"')) {
                        if (line.indexOf(part + ':') !== -1 || line.indexOf(part + ' :') !== -1) {
                            return (0, jsx_runtime_1.jsx)("span", { className: "syntax-json-key", children: part }, pIdx);
                        }
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-json-str", children: part }, pIdx);
                    }
                    if (/^:\s*(true|false|null|\d+)$/.test(part)) {
                        return (0, jsx_runtime_1.jsx)("span", { className: "syntax-json-val", children: part }, pIdx);
                    }
                    return (0, jsx_runtime_1.jsx)("span", { children: part }, pIdx);
                }) }, idx));
        });
    }
    // Markdown syntax highlighting inside code block
    if (lang === 'markdown' || lang === 'md') {
        const lines = code.split('\n');
        return lines.map((line, idx) => {
            let lineClass = '';
            if (line.startsWith('#'))
                lineClass = 'syntax-diff-header';
            else if (line.startsWith('- ') || line.startsWith('* '))
                lineClass = 'syntax-ini-key';
            else if (line.startsWith('>'))
                lineClass = 'syntax-yaml-val';
            return ((0, jsx_runtime_1.jsx)("div", { className: `syntax-line ${lineClass}`, children: line || ' ' }, idx));
        });
    }
    // Default plain monospace text
    return (0, jsx_runtime_1.jsx)("code", { children: code });
};
const CodeBlockWrapper = ({ code, language = '' }) => {
    const [copied, setCopied] = (0, react_1.useState)(false);
    const handleCopy = (e) => {
        e.stopPropagation();
        try {
            navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
        catch { /* ignore */ }
    };
    const displayLang = language ? language.toUpperCase() : null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-code-block-wrapper", children: [(0, jsx_runtime_1.jsxs)("div", { className: "discord-code-header", children: [displayLang ? ((0, jsx_runtime_1.jsx)("span", { className: "discord-code-lang-tag", children: displayLang })) : ((0, jsx_runtime_1.jsx)("span", { className: "discord-code-lang-tag", children: "KOD" })), (0, jsx_runtime_1.jsx)("button", { className: "code-copy-btn", onClick: handleCopy, type: "button", children: copied ? '✓ Kopyalandı' : 'Kopyala' })] }), (0, jsx_runtime_1.jsx)("pre", { className: `discord-code-block ${language ? `lang-${language.toLowerCase()}` : ''}`, children: renderHighlightedCode(code, language) })] }));
};
exports.CodeBlockWrapper = CodeBlockWrapper;
/**
 * Parses inline markdown: bold, italic, links, mentions, inline code, timestamps, emojis.
 */
const parseInlineMarkdown = (text) => {
    if (!text)
        return null;
    const inlineRegex = /(`[^`\n]+`|<t:\d+(?::[a-zA-Z])?>|<@!?[a-zA-Z0-9_-]+>|<#[a-zA-Z0-9_-]+>|@everyone|@here|@[a-zA-Z0-9_.-]+|\[[^\]]+\]\(https?:\/\/[^\s)]+\)|https?:\/\/[^\s<]+|\|\|[\s\S]+?\|\||\*\*\*[\s\S]+?\*\*\*|\*\*[\s\S]+?\*\*|__[\s\S]+?__|~~[\s\S]+?~~|\*[^*\n]+\*|_[^_\n]+_)/g;
    const parts = text.split(inlineRegex);
    return parts.map((part, index) => {
        if (!part)
            return null;
        // Inline code: `code`
        if (part.startsWith('`') && part.endsWith('`') && part.length >= 2) {
            const content = part.slice(1, -1);
            return ((0, jsx_runtime_1.jsx)("code", { className: "discord-inline-code", children: (0, exports.parseEmojiShortcodes)(content) }, index));
        }
        // Discord Timestamp: <t:1672531199:R>
        const timestampMatch = part.match(/^<t:(\d+)(?::([a-zA-Z]))?>$/);
        if (timestampMatch) {
            const unixSec = parseInt(timestampMatch[1], 10);
            const style = timestampMatch[2];
            const { text: formattedText, full } = formatDiscordTimestamp(unixSec, style);
            return ((0, jsx_runtime_1.jsx)("span", { className: "discord-timestamp", title: full, children: formattedText }, index));
        }
        // Mentions: @everyone, @here, <@id>, @user
        if (part === '@everyone' || part === '@here') {
            return ((0, jsx_runtime_1.jsx)("span", { className: "discord-mention mention-everyone", children: part }, index));
        }
        if (part.startsWith('<@') || part.startsWith('<#') || part.startsWith('@')) {
            const isChannel = part.startsWith('<#');
            const cleanName = part.replace(/^<[@#]!?/, '').replace(/>$/, '');
            return ((0, jsx_runtime_1.jsx)("span", { className: `discord-mention ${isChannel ? 'mention-channel' : ''}`, children: isChannel ? `#${cleanName}` : (part.startsWith('@') ? part : `@${cleanName}`) }, index));
        }
        // Markdown link: [text](url)
        const linkMatch = part.match(/^\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)$/);
        if (linkMatch) {
            return ((0, jsx_runtime_1.jsx)("a", { href: linkMatch[2], target: "_blank", rel: "noopener noreferrer", className: "message-link-highlight", onClick: (e) => e.stopPropagation(), children: (0, exports.parseEmojiShortcodes)(linkMatch[1]) }, index));
        }
        // Raw URL
        if (part.match(/^https?:\/\/[^\s<]+$/)) {
            return ((0, jsx_runtime_1.jsx)("a", { href: part, target: "_blank", rel: "noopener noreferrer", className: "message-link-highlight", onClick: (e) => e.stopPropagation(), children: part }, index));
        }
        // Spoiler: ||text||
        if (part.startsWith('||') && part.endsWith('||') && part.length >= 4) {
            const content = part.slice(2, -2);
            return ((0, jsx_runtime_1.jsx)("span", { className: "markdown-spoiler", onClick: (e) => {
                    e.stopPropagation();
                    e.currentTarget.classList.toggle('revealed');
                }, children: (0, exports.parseInlineMarkdown)(content) }, index));
        }
        // Bold-Italic: ***text***
        if (part.startsWith('***') && part.endsWith('***') && part.length >= 6) {
            const content = part.slice(3, -3);
            return ((0, jsx_runtime_1.jsx)("strong", { className: "markdown-bold", children: (0, jsx_runtime_1.jsx)("em", { className: "markdown-italic", children: (0, exports.parseInlineMarkdown)(content) }) }, index));
        }
        // Bold: **text**
        if (part.startsWith('**') && part.endsWith('**') && part.length >= 4) {
            const content = part.slice(2, -2);
            return ((0, jsx_runtime_1.jsx)("strong", { className: "markdown-bold", children: (0, exports.parseInlineMarkdown)(content) }, index));
        }
        // Underline: __text__
        if (part.startsWith('__') && part.endsWith('__') && part.length >= 4) {
            const content = part.slice(2, -2);
            return ((0, jsx_runtime_1.jsx)("u", { className: "markdown-underline", children: (0, exports.parseInlineMarkdown)(content) }, index));
        }
        // Strikethrough: ~~text~~
        if (part.startsWith('~~') && part.endsWith('~~') && part.length >= 4) {
            const content = part.slice(2, -2);
            return ((0, jsx_runtime_1.jsx)("del", { className: "markdown-strikethrough", children: (0, exports.parseInlineMarkdown)(content) }, index));
        }
        // Italic: *text* or _text_
        if ((part.startsWith('*') && part.endsWith('*') && part.length >= 2) ||
            (part.startsWith('_') && part.endsWith('_') && part.length >= 2)) {
            const content = part.slice(1, -1);
            return ((0, jsx_runtime_1.jsx)("em", { className: "markdown-italic", children: (0, exports.parseInlineMarkdown)(content) }, index));
        }
        return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, exports.parseEmojiShortcodes)(part) }, index);
    });
};
exports.parseInlineMarkdown = parseInlineMarkdown;
/**
 * Main Markdown Parser
 * Seamlessly parses multiline codeblocks (including malformed or single-backtick endings)
 * without line splitting issues.
 */
const renderMarkdown = (text) => {
    if (!text)
        return null;
    // Codeblock regex: matches ```[lang][body](``` | ` | $)
    const codeBlockRegex = /```([a-zA-Z0-9_#+.-]+)?[\r\n\s]*([\s\S]*?)(?:```|(?:\r?\n|^)\s*`+\s*(?=\r?\n|$)|`+\s*$|$)/g;
    const elements = [];
    let lastIndex = 0;
    let match;
    while ((match = codeBlockRegex.exec(text)) !== null) {
        // 1. Text segment before codeblock
        if (match.index > lastIndex) {
            const plainSegment = text.slice(lastIndex, match.index);
            elements.push(renderTextWithLines(plainSegment, `plain-${lastIndex}`));
        }
        // 2. Extract language and code body
        let rawLang = (match[1] || '').trim().toLowerCase();
        let codeBody = match[2] || '';
        // Check if rawLang contains attached body (e.g. ```yamlSaat: 16:38:47` or ```textTürkiye...)
        if (rawLang) {
            for (const known of KNOWN_LANGUAGES) {
                if (rawLang.startsWith(known) && rawLang.length > known.length) {
                    const rest = rawLang.slice(known.length);
                    rawLang = known;
                    codeBody = rest + (codeBody ? '\n' + codeBody : '');
                    break;
                }
            }
        }
        // Clean up trailing single/multiple backticks or stray quotes from malformed webhook generators
        codeBody = codeBody.replace(/`+$/, '').trimEnd();
        // Clean leading newline if language was on its own line
        codeBody = codeBody.replace(/^[\r\n]+/, '');
        elements.push((0, jsx_runtime_1.jsx)(exports.CodeBlockWrapper, { code: codeBody, language: rawLang }, `code-${match.index}`));
        lastIndex = codeBlockRegex.lastIndex;
        // Guard against zero-length infinite match
        if (match[0].length === 0) {
            codeBlockRegex.lastIndex++;
        }
    }
    // 3. Trailing text segment
    if (lastIndex < text.length) {
        const trailingSegment = text.slice(lastIndex);
        elements.push(renderTextWithLines(trailingSegment, `plain-${lastIndex}`));
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: elements });
};
exports.renderMarkdown = renderMarkdown;
/**
 * Helper to render non-codeblock text lines with blockquote and paragraph support
 */
const renderTextWithLines = (text, keyPrefix) => {
    if (!text)
        return null;
    const lines = text.split('\n');
    return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: lines.map((line, lineIdx) => {
            // Discord Blockquote (> text or >>> text)
            if (line.startsWith('> ') || line.startsWith('>>> ')) {
                const quoteText = line.replace(/^>+\s*/, '');
                return ((0, jsx_runtime_1.jsx)("blockquote", { className: "discord-blockquote", children: (0, exports.parseInlineMarkdown)(quoteText) }, `${keyPrefix}-q-${lineIdx}`));
            }
            // Headers
            if (line.startsWith('### ')) {
                return ((0, jsx_runtime_1.jsx)("h4", { className: "discord-h3", children: (0, exports.parseInlineMarkdown)(line.slice(4)) }, `${keyPrefix}-h3-${lineIdx}`));
            }
            if (line.startsWith('## ')) {
                return ((0, jsx_runtime_1.jsx)("h3", { className: "discord-h2", children: (0, exports.parseInlineMarkdown)(line.slice(3)) }, `${keyPrefix}-h2-${lineIdx}`));
            }
            if (line.startsWith('# ')) {
                return ((0, jsx_runtime_1.jsx)("h2", { className: "discord-h1", children: (0, exports.parseInlineMarkdown)(line.slice(2)) }, `${keyPrefix}-h1-${lineIdx}`));
            }
            return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [lineIdx > 0 && (0, jsx_runtime_1.jsx)("br", {}), (0, exports.parseInlineMarkdown)(line)] }, `${keyPrefix}-l-${lineIdx}`));
        }) }, keyPrefix));
};
